export { renderMenuItem_unstable as renderMenuItem } from '@fluentui/react-menu';
